'use strict';
import { j as e } from "../../external/react/jsx-runtime.js";
import i from "./timeline-section.module.scss.js";
const o = [
  {
    id: "quiz",
    name: "Quiz"
  },
  {
    id: "review",
    name: "Doctor review"
  },
  {
    id: "plan",
    name: "Your plan"
  },
  {
    id: "checkout",
    name: "Checkout"
  }
], c = ({ items: s, step: a }) => /* @__PURE__ */ e.jsx("section", { className: i["timeline-section"], children: s.map((n, t) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: i["timeline-section--item"],
    "data-item-active": t === a - 1,
    "data-item-pending": t > a - 1,
    children: [
      /* @__PURE__ */ e.jsx("div", { className: i.border, "aria-hidden": !0 }),
      /* @__PURE__ */ e.jsx("small", { children: n.name })
    ]
  },
  n.id
)) });
export {
  c as default,
  o as quizTimeline
};
